import React, {Component} from 'react';
import { withDomains, RESTExecutor } from '../../../lib/domain'
import { Spin, Row, Input, Button, InputNumber, message } from 'antd';
import { showErrorInNotification } from '../../../lib/util';


class PipelineGeneral extends Component {
    constructor(props) {
        super(props)

        const { name ,normalizer_config,description} = this.props.pipeline_data;
        this.state = {
            pipeline_data: { name,normalizer_config,description }
        };
        this.pipeline_id = this.props.pipeline_id;
        this.datatype_id=this.props.datatype_id;
        this.has_changed=false;

        this.patch_pipeline=RESTExecutor.patch().config({
            label:'pipeline_detail',
            params:{
                datatype_id:"",
                pipeline_id:""
            }
        }).callbacks((success)=>{
            message.success("Updated Successfully")
            typeof this.props.onPipelineChange==='function' &&  this.props.onPipelineChange()
        },(error)=>{
            showErrorInNotification(error)
        }).connect(props.domains.datatype);

    };


    stateUpdater = ({ stateKey, valueKey, value, appendObj = {}, callback }) => {
        let newData = this.state[stateKey];
        this.has_changed=true;
        if (valueKey) {
            newData[valueKey] = value;
        }
        if (appendObj) {
            Object.assign(newData, appendObj)
        }
        console.log(newData);
        this.setState({
            [stateKey]: newData
        }, () => {
            typeof callback === 'function' && callback()
        })
    }

     render() {

        if (!this.props.pipeline_id) {
            return <Spin />
        }

        let patch_pipeline_resp=this.patch_pipeline.response();

        const { pipeline_data } = this.state;
        // let formatted_normalizer = pipeline_data.normalizer_config || "";
        // if (typeof pipeline_data.normalizer_config === 'object') {
        //     formatted_normalizer = JSON.stringify(pipeline_data.normalizer_config, null, 4);
        // }
        return (
        <div><div style={{
                display:'flex',
                flexDirection:'column',
                justifyContent:'space-between',
            }}>
                <Row type='flex' justify='center' style={{
                    flex:1
                }}>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: 'fit-content',
                        textAlign: 'right',
                        justifyContent:'center'
                    }}
                    >
                        <span>Pipeline Name:  &nbsp;  <Input
                            placeholder={"Pipeline  Name"}
                            onChange={(e) => {
                                this.stateUpdater({ stateKey: 'pipeline_data', valueKey: 'name', value: e.target.value })
                            }}
                            value={pipeline_data.name}
                            style={{
                                width: 300
                            }} >
                        </Input>
                        </span>
                        <br></br>
                        <span>Pipeline Description: &nbsp; <Input.TextArea
                            placeholder={"Pipeline  Description"}
                            onChange={(e) => {
                                this.stateUpdater({ stateKey: 'pipeline_data', valueKey: 'description', value: e.target.value })
                            }}
                            rows={2}
                            value={pipeline_data.description}
                            style={{
                                width: 300
                            }} >
                        </Input.TextArea>
                        </span>
                        {/* <br></br>
                        <br></br> 
                        <span >Normalizer Config: &nbsp;
                        <Input.TextArea
                            placeholder="Normalizer Config"
                            value={formatted_normalizer}
                            style={{
                                width:300
                            }}
                            autosize={{
                                maxRows:6
                            }}

                            onChange={(e) => {

                                let d = e.target.value;
                                try {
                                    d = JSON.parse(d);
                                } catch (e) {

                                }

                                this.stateUpdater({
                                    stateKey: 'pipeline_data',
                                    valueKey: 'normalizer_config',
                                    value: d,
                                });
                            }}
                            rows={2} />
                        </span> */}
                    </div>
                </Row>
                <br></br>
                <br></br>
                <Row type='flex' justify='space-between'>
                    <div></div>
                    <div><Button type='primary'
                    disabled={!this.has_changed || patch_pipeline_resp.fetching}
                    loading={patch_pipeline_resp.fetching}
                    onClick={()=>{
                        this.patch_pipeline.config({
                            params:{
                                datatype_id:this.datatype_id,
                                pipeline_id:this.pipeline_id
                            }
                        }).execute(pipeline_data)
                    }}
                    >Submit</Button></div>
                </Row>
            </div>
            </div>
        )
    }
    componentDidUpdate = (prevProps) => {
        if (this.props.pipeline_id !== prevProps.pipeline_id||
            this.props.datatype_id !== prevProps.datatype_id||
            this.props.pipeline_data !== prevProps.pipeline_data) {
            // console.log("props change",this.props)
            this.pipeline_id = this.props.pipeline_id;
            this.datatype_id=this.props.datatype_id;
            this.patch_pipeline.forId(this.pipeline_id);
            let { name ,normalizer_config,description} = this.props.pipeline_data;
            // console.log("name",name)
            this.setState({
                pipeline_data: { name ,normalizer_config,description}
            });

            // fetch the new product based and set it to the state of the component
        };
    }
}

export default withDomains(PipelineGeneral,"datatype");
